<template>
  <div class="box">
    <el-card v-show="!collapsed" shadow="never">
      <div class="notCollapsed">
        <el-row class="row" :gutter="40">
          <el-col :span="8" class="column1">
            <!-- <div class="title">{{ $t('projectName') }}</div> -->
            <div class="title">{{ sysSetting.projectName }}</div>
            <div class="detail">
              <el-row>
                <el-col :span="11" ref="image">
                  <el-image :src="building" fit="contain"></el-image>
                </el-col>
                <el-col :span="13" class="row1_column2">
                  <div class="content">
                    <div class="inlineContent">
                      <span class="name" :title="$t('agencyName')">{{ $t('agencyName') }}: </span>
                      <span  :title="sysSetting.distributorName">{{sysSetting.distributorName}}</span>
                    </div>
                    <div class="inlineContent">
                      <span class="name" :title="$t('fieldStaffName')">{{ $t('fieldStaffName') }}: </span>
                      <span :title="sysSetting.sitePerson">{{sysSetting.sitePerson}}</span>
                    </div>
                    <div class="inlineContent">
                      <span class="name" :title="$t('fieldStaffPhone')">{{ $t('fieldStaffPhone') }}: </span>
                      <span :title="sysSetting.sitePersonPhone">{{ sysSetting.sitePersonPhone }}</span>
                    </div>
                    <div class="inlineContent">
                      <span class="name" :title="$t('fieldStaffJob')">{{ $t('fieldStaffJob') }}: </span>
                      <span :title="sysSetting.sitePersonDuty">{{ sysSetting.sitePersonDuty }}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="8" class="column2" ref="column2">
            <div class="middle">
              <!-- <div class="title">{{ $t('jbf') }}</div> -->
              <div class="title">{{ sysSetting.model }}</div>
              <el-button class="shutdown" type="danger" plain icon="iconfont icontuichu" @click="_stopRecord"></el-button>
              <!-- <div class="content">{{ $t('chinese') }}</div> -->
              <div class="content">{{language }}</div>
              <!-- <div class="content">12:01:01</div> -->
              <div class="content">{{nowDateTime}}</div>
            </div>
            <div class="detail">
              <el-row>
                <el-col :span="11">
                  <el-image :src="jbf" fit="contain"></el-image>
                </el-col>
                <el-col :span="13" class="row1_column2">
                  <div class="content">
                    <div class="inlineContent">
                      <span>{{sysSetting.psn}}</span>
                    </div>
                    <div class="inlineContent" >
                      <span class="name" >{{ $t('panelNumber') }}: </span>
                      <span>{{sysSetting.controllerNo}} </span>
                    </div>
                    <div class="inlineContent">
                      <span class="name">{{ $t('manual') }}: </span>
                      <span>{{sysSetting.manual ? $t('allow') : $t('disable')}}</span>
                    </div>
                    <div class="inlineContent">
                      <span class="name">{{ $t('auto') }}: </span>
                      <span>{{sysSetting.automatic ? $t('allow') : $t('disable')}}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="8" class="column3">
            <div class="light">
              <el-image :src="redSrc" class="redLight" fit="contain"></el-image>
              <el-image :src="yellowSrc" fit="contain"></el-image>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-button class="btn" type="primary" plain @click="_recordOperation(2)" :loading="soundingStart">{{ $t('soundAndLightStart') }}</el-button>
              </el-col>
              <el-col :span="12">
                <el-button class="btn" type="primary" plain @click="_recordOperation(3)" :loading="soundingStop">{{ $t('soundAndLightStop') }}</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-button class="btn" type="primary" plain @click="_recordOperation(4)" :loading="silencing">{{ $t('silencing') }}</el-button>
              </el-col>
              <el-col :span="12">
                <el-button class="btn" type="primary" plain @click="_recordOperation(1)" :loading="reseting">{{ $t('reset') }}</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-button class="btn" type="primary" plain @click="_recordOperation(5)" :loading="proofreading">{{ $t('proofreading') }}</el-button>
              </el-col>
              <el-col :span="12">
                <!-- <el-button class="btn" type="primary" plain>{{ $t('inspect') }}</el-button> -->
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-image @click="changeCollapsed" class="zoomIn" :src="zoomOut" fit="contain"></el-image>
      </div>
    </el-card>
    <el-card v-show="collapsed" shadow="never">
      <div class="collapsed">
        <el-row class="row" :gutter="40">
          <el-col class="column1" :span="8">
            <div class="title">{{ sysSetting.projectName }}</div>
          </el-col>
          <el-col class="column2" :span="8">
            <div class="middle">
              <div class="title">{{ sysSetting.model }}</div>
              <el-button class="shutdown" type="danger" plain icon="iconfont icontuichu" @click="_stopRecord"></el-button>
              <div class="content">{{ language }}</div>
              <div class="content">{{ nowDateTime }}</div>
            </div>
          </el-col>
          <el-col class="column3" :span="8">
            <div class="light">
              <el-image :src="redSrc" fit="contain"></el-image>
              <el-image :src="yellowSrc" fit="contain"></el-image>
            </div>
          </el-col>
        </el-row>
        <el-image @click="changeCollapsed" class="zoomOut" :src="zoomIn" fit="contain"></el-image>
      </div>
    </el-card>
  </div>
</template>

<script>
import building from 'assets/img/box/building.png'
import jbf from 'assets/img/box/jbf.png'
import none from 'assets/img/box/none.png'
import redLight from 'assets/img/box/redLight.png'
import yellow from 'assets/img/box/yellow.png'
import zoomIn from 'assets/img/box/zoomIn.png'
import zoomOut from 'assets/img/box/zoomOut.png'
import {recordOperation, stopRecord} from 'api/query'
import Status from "components/Status";
// eslint-disable-next-line no-unused-vars
import {formatDate} from "assets/utils";
export default {
  name: "Box",
  mixins: [Status],
  props: {
  },
  data() {
    return {
      building,
      jbf,
      redSrc:"",
      yellowSrc:"",
      zoomIn,
      zoomOut,
      redLight,
      none,
      yellow,
      lineHeight: null,
      btnHeight: null,
      nowDateTime: '',
      soundingStart: false,
      soundingStop: false,
      silencing: false,
      reseting: false,
      proofreading: false
    }
  },
  watch: {
    collapsed() {
      // this.resizeHeight()
    },
    alarmFlag(val) {
      if (val) {
        this.redSrc = this.redLight;
      } else {
        this.redSrc = this.none;
      }
    },
    faultFlag(val) {
      if (val) {
        this.yellowSrc = this.yellow;
      } else {
        this.redSrc = this.none;
      }
    },
  },
  computed: {
    alarmFlag() {
      return this.fireCount !== "0000" || this.regularCount !== "0000" || this.shieldCount !== "0000" || this.feedbackCount !== "0000"
    },
    faultFlag() {
      return this.faultCount !== "0000"
    },
    fireCount() {
      return this.$store.state.fireCount
    },
    faultCount() {
      return this.$store.state.faultCount
    },
    regularCount() {
      return this.$store.state.regularCount
    },
    shieldCount() {
      return this.$store.state.shieldCount
    },
    feedbackCount() {
      return this.$store.state.feedbackCount
    },
    collapsed (){
      return this.$store.state.collapsed
    },
    sysSetting() {
      return this.$store.state.sysSetting
    },
    controllInfo() {
      return this.$store.state.controlInfo
    },
    setDate() {
      // console.log(this.$formatDate(this.date, 'yyyy-MM-dd hh:mm:ss'));
      return this.formatDate(this.date, 'yyyy-MM-dd hh:mm:ss')
    },
    language(){
      return this.$store.state.language === 'chinese' ? this.$t('chinese') : this.$t('english')
    },
    muteFlag(){
      return this.$store.state.muteFlag
    },
  },
  created() {
    this.currentTime();
    this.redSrc = this.none;
    this.yellowSrc = this.none;
  },
  mounted(){},
  methods: {
    currentTime(){
      setInterval(this.getTime,500)
    },
    getTime(){
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
      _this.nowDateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
    },
    _stopRecord() {
      stopRecord({controllerPsn: this.controllInfo.controllerPsn, id: this.sysSetting.recordId}).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.message)
          this.$router.push('/index/2')
          let formData = JSON.parse(sessionStorage.formData)
          let userInfo = JSON.parse(localStorage.user_info)
          let access_token = localStorage.access_token
          sessionStorage.clear();
          localStorage.clear()
          localStorage.setItem('access_token', access_token);
          this.$store.commit('setToken', access_token);
          localStorage.setItem('user_info', JSON.stringify(userInfo));
          this.$store.commit('setUserInfo', userInfo);
          sessionStorage.formData = JSON.stringify(formData);
          this.$store.commit('setFormData', formData);
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    _recordOperation(type) {
      if (type === 2) {
        this.soundingStart = true
      } else if (type === 3) {
        this.soundingStop = true
      } else if (type === 4) {
        this.silencing = true
      } else if (type === 1) {
        this.reseting = true
      } else if (type === 5) {
        this.proofreading = true
      }
      this.show()
      let param = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.controllInfo.controllerNo,
        operation: type
      }
      recordOperation(param).then((res) => {
        if (res.code === 1) {
          this.success(res.message ? res.message : '操作成功')
        }
        if (type === 2) {
          this.soundingStart = false
        } else if (type === 3) {
          this.soundingStop = false
        } else if (type === 4) {
          this.silencing = false
        } else if (type === 1) {
          this.reseting = false
        } else if (type === 5) {
          this.proofreading = false
        }
      }).catch(() => {
        this.failed()
        if (type === 2) {
          this.soundingStart = false
        } else if (type === 3) {
          this.soundingStop = false
        } else if (type === 4) {
          this.silencing = false
        } else if (type === 1) {
          this.reseting = false
        } else if (type === 5) {
          this.proofreading = false
        }
      })
    },
    changeCollapsed() {
      this.$store.commit('setCollapsed', !this.collapsed);
      sessionStorage.collapsed = this.collapsed
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  margin-bottom: 10px;
  .notCollapsed {
    position: relative;
    .row {
      .column1 {
        border-right: 1px dashed #487499FF;
        .title {
          font-weight: bold;
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold;
          height: 40px;
          color: #2F4E68FF;
        }
        .detail {
          .row1_column2 {
            .content {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              font-size: 12px;
              color: #487499FF;
              text-align: left;

              .inlineContent {
                display: flex;
                padding-left: 20px;
                height: 46px;
                line-height: 46px;
                .name {
                  width: 100px;
                  margin-right: 2px;
                }

                > span {
                  white-space: nowrap;
                  word-break: break-all;
                  overflow: hidden;
                }
              }
            }
          }
        }
      }

      .column2 {
        border-right: 1px dashed #487499FF;

        .middle {
          display: inline-block;
          width: 100%;
          height: 40px;

          .title {
            font-weight: bold;
            font-size: 16px;
            font-family: MicrosoftYaHei-Bold;
            line-height: 30px;
            color: #2F4E68FF;
            float: left;
            margin-bottom: 15px;
          }

          .content {
            float: right;
            line-height: 30px;
            color: #2F4E68FF;
            margin-right: 12px;
          }

          .el-button {
            float: right;

            &.shutdown {
              padding: 7px 7px !important;
            }
          }
        }
        .detail {
          .row1_column2 {
            .content {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              font-size: 12px;
              color: #487499FF;
              text-align: left;

              .inlineContent {
                display: flex;
                vertical-align: middle;
                padding-left: 20px;
                height: 46px;
                line-height: 46px;
                .name {
                  width: 90px;
                }
                > span {
                  white-space: nowrap;
                  word-break: break-all;
                  overflow: hidden;
                }
              }
            }
          }
        }
      }
      .column3 {
        padding: 0 38px !important;
        .light {
          height: 50px;
          line-height: 50px;
          display: flex;
          justify-content: center;
          text-align: center;
          .redLight {
            margin-right: 40px;
          }
        }
        .el-row {
          height: 50px;
          line-height: 50px;
          .el-col {
            padding-right: 8px;
            &:nth-child(3n) {
              padding-right: 0px;
            }
            .el-button {
              width: 100%;
              background-color: #E6F1FC !important;
              border-color: #9EC8EF !important;
            }
            .el-button--primary.is-plain:hover{
              color: #0F8BC0 !important;
            }
          }

          .close-col {
            padding-right: 0px;
          }
        }
      }
    }

    .zoomIn {
      position: absolute;
      right: -18px;
      bottom: -18px;
      width: 20px;
      height: 20px;
    }
  }

  .collapsed {
    position: relative;

    .row {
      .column1 {
        border-right: 1px dashed #487499FF;

        .title {
          font-weight: bold;
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold;
          line-height: 30px;
          color: #2F4E68FF;
        }
      }

      .column2 {
        border-right: 1px dashed #487499FF;

        .middle {
          overflow: hidden;

          .title {
            font-weight: bold;
            font-size: 16px;
            font-family: MicrosoftYaHei-Bold;
            line-height: 30px;
            color: #2F4E68FF;
            float: left;
          }

          .content {
            float: right;
            line-height: 30px;
            color: #2F4E68FF;
            margin-right: 12px;
          }

          .el-button {
            float: right;
            &.shutdown {
              padding: 7px 7px !important;
            }
          }
        }
      }

      .column3 {
        .light {
          display: flex;
          justify-content: center;
          margin-top: 5px;
          text-align: center;

          .el-image {
            margin-right: 40px;
          }
        }
      }
    }

    .zoomOut {
      position: absolute;
      right: -18px;
      top: -18px;
      width: 20px;
      height: 20px;
    }
  }

  .loading-container{
    background-color: rgba(0,0,0, 0.7);
    position :fixed;
    width :100%;
    height :100%;
    top :0;
    left :0;
    z-index :10000;
  }
}
</style>
